/**
 * COURE.QUIZ.SERVICE.API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Status } from './status';

export interface CampaignDetailsDto { 
    id?: string;
    campaignName?: string;
    campaignDescription?: string;
    shortcode?: string;
    serviceId?: string;
    keyword?: string;
    status?: Status;
    dateCrated?: Date;
}